
import ShoppingCart from "../../../assets/filled/ShoppingCart.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ShoppingCartIcon({ className, dataTestid = "ShoppingCartIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ShoppingCart data-testid={dataTestid} className={classes} {...rest} />
  );
}
